import React from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { fmtDate, fmtDateTime, fmtNumber } from './periodUtils';

// Карточка записи в режиме просмотра. Правка и удаление в объём UC.08.02 не входят —
// кнопок сохранения/удаления нет.
export default function IndicatorValueView({ open, row, indicators, dataLang, onClose }) {
  const { t } = useTranslation();
  if (!row) return null;

  const it = indicators.find((x) => x.id === row.indicator_id) || {};
  const nm = (o, base) => (o ? o[`${base}_${dataLang}`] : null);
  const dash = (v) =>
    v === null || v === undefined || v === '' ? <span className="ai-dash">—</span> : v;

  const rows = [
    [t('analyticsIndicators.form.indicator'), nm(it, 'name')],
    [t('analyticsIndicators.view.sector'), nm(it, 'sector') || <span className="ai-dash">—</span>],
    [t('analyticsIndicators.form.periodType'), t(`analyticsIndicators.pt.${row.period_type}`)],
    [
      t('analyticsIndicators.view.range'),
      `${fmtDate(row.period_start)} – ${fmtDate(row.period_end)}`,
    ],
    [t('analyticsIndicators.form.comment'), row[`period_label_${dataLang}`]],
    [t('analyticsIndicators.form.value'), dash(fmtNumber(row.value))],
    [t('analyticsIndicators.form.unit'), nm(it, 'unit')],
    [t('analyticsIndicators.view.created'), fmtDateTime(row.created_at)],
    [t('analyticsIndicators.view.by'), row[`created_by_${dataLang}`]],
  ];

  return (
    <Modal
      className="ai-modal"
      open={open}
      width={640}
      title={t('analyticsIndicators.view.title')}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          {t('analyticsIndicators.close')}
        </Button>,
      ]}
    >
      {rows.map(([k, v]) => (
        <div className="ai-view-row" key={k}>
          <div className="ai-view-row__k">{k}</div>
          <div className="ai-view-row__v">{v}</div>
        </div>
      ))}
    </Modal>
  );
}
